import {createFileRoute} from '@tanstack/react-router';
import {QuizPage} from './quiz';

// The quiz build's activation step — its own query-less URL so AdSense Offerwall URL rules can
// target it (mirrors /americanos/activate/). Free quiz builds arrive here via a REAL page load
// (the Offerwall only evaluates its URL rules on a page view, never on SPA navigation); the same
// QuizPage component then resumes the stashed build. Paid returns (Event Pass) deliberately land
// on /quiz/ instead, so nobody who has paid is ever gated by the wall.
export const Route = createFileRoute('/quiz/activate')({
    component: QuizPage,
});
